import { pick, pickBy } from "lodash";

import { GoalBasedFinancingRecord } from "@fartherfinance/frontend/api/FinancialPlans/goals/types";
import { GoalBasedFinancialPlanSingleResponse } from "@fartherfinance/frontend/api/FinancialPlans/plan/types";

import { PageIndex, ProgressPointState } from "./reducer/types";

const NotStarted: Extract<ProgressPointState, "NotStarted"> = "NotStarted";
const InProgress: Extract<ProgressPointState, "InProgress"> = "InProgress";
const Complete: Extract<ProgressPointState, "Complete"> = "Complete";

export const getProgressStateFromPageIndex = (
  pageIndex: PageIndex,
  plan: GoalBasedFinancialPlanSingleResponse | undefined
) => {
  const hasGoals = plan?.goals?.length ?? 0 > 0 ? Complete : NotStarted;
  const hasAssets = plan?.accounts?.length ?? 0 > 0 ? Complete : NotStarted;
  const hasIncome = plan?.income?.length ?? 0 > 0 ? Complete : NotStarted;
  const hasSavings = plan?.savings?.length ?? 0 > 0 ? Complete : NotStarted;
  const hasExpenses = plan?.expenses?.length ?? 0 > 0 ? Complete : NotStarted;
  const hasInsurance = plan?.insurance?.length ?? 0 > 0 ? Complete : NotStarted;

  return [
    { name: "Goals", state: pageIndex === 1 ? InProgress : hasGoals },
    { name: "Assets", state: pageIndex === 2 ? InProgress : hasAssets },
    { name: "Income", state: pageIndex === 3 ? InProgress : hasIncome },
    { name: "Savings", state: pageIndex === 4 ? InProgress : hasSavings },
    { name: "Expenses", state: pageIndex === 5 ? InProgress : hasExpenses },
    { name: "Insurance", state: pageIndex === 6 ? InProgress : hasInsurance },
  ];
};

export const filterValidFinancingValues = ({
  type,
  financing,
}: {
  type: string;
  financing: GoalBasedFinancingRecord;
}) => {
  const cashFields = ["yearOfSale", "costOfSale"];

  const loanFields = [
    "downPayment",
    "term",
    "interestRate",
    "yearOfSale",
    "costOfSale",
  ];

  const leaseFields = [...loanFields, "residualValue"];

  const pickedFields = () => {
    switch (type) {
      case "Loan":
        return pick(financing, loanFields);
      case "Lease":
        return pick(financing, leaseFields);
      default:
        return pick(financing, cashFields);
    }
  };

  return pickBy(pickedFields(), (value) => value !== undefined && value !== "");
};
